import React from 'react'

const ViewBarArrowAlphUp = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.3 28.3">
    <path d="M23.2 22.5h-5.9l-1.4 3.7h-2l5.3-13.4h2.1l5.3 13.4h-2l-1.4-3.7zM18 20.7h4.6l-2.3-6-2.3 6z" />
    <path d="M14.6 5.8L9.1.3c-.4-.4-1.2-.4-1.6 0L2 5.8c-.2.2-.3.5-.3.8 0 .3.1.6.3.8.4.4 1.2.4 1.6 0l3.5-3.5v23.3c0 .6.5 1.1 1.2 1.1.6 0 1.1-.5 1.1-1.1V3.9L13 7.4c.4.4 1.2.4 1.6 0 .2-.2.3-.5.3-.8 0-.3-.1-.6-.3-.8z" />
  </svg>
)

export default ViewBarArrowAlphUp
